import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from '../../features/dashboard';
import SavedCards from '../../features/savedCards';
import BankAccounts from '../../features/bankAccounts';
import WalletStatement from '../../features/walletStatement';
import UserProfile from '../../features/UserProfile';
import AddMoney from '../../features/payments';
import TransactionLimit from '../../features/transactionLimit';
import SideBar from '../../features/nav/SideBar';
import LoginHOC from '../../features/auth/LoginHOC';
import Walletfailure from '../../features/payments/component/Walletfailure';
import Walletsuccess from '../../features/payments/component/Walletsuccess';

class FeatureRoute extends Component {
  render() {
    return (
      <React.Fragment>
        <SideBar>
          <Switch>
            <Route exact path="/accounts/dashboard" component={LoginHOC(Dashboard)} />
            <Route exact path="/accounts/cash" component={LoginHOC(AddMoney)} />
            <Route exact path="/accounts/stored" component={LoginHOC(SavedCards)} />
            <Route exact path="/accounts/banks" component={LoginHOC(BankAccounts)} />
            <Route exact path="/accounts/statement" component={LoginHOC(WalletStatement)} />
            <Route exact path="/accounts/profile" component={LoginHOC(UserProfile)} />
            <Route exact path="/accounts/limits" component={LoginHOC(TransactionLimit)} />
            <Route exact path="/accounts/walletsuccess" component={Walletsuccess} />
            <Route exact path="/accounts/walletfailure" component={Walletfailure} />
          </Switch>
        </SideBar>
      </React.Fragment>
    );
  }
}

export default FeatureRoute;
